import React, { useCallback, useEffect, useMemo, useState } from "react";
import { dataSource } from "../../../services/dataSource";
import { LANG_V2, REP_V2 } from "../../../shared/Data/typeDirs";
import { ReportV2 } from "../../../shared/Objects/newReportObjects/report_v2";
import { NewControlManager } from "../../newControlManager";
import { useAppContainerContext } from "../appContainer/context";
import { useNavigate, useLocation } from "react-router-dom";
import { getURLDetails } from "../utils";
import { ReportBodyWrapper } from "../../newControlManager/controlWrappers/reports_v2/body";
import { ReportHeaderWrapper } from "../../newControlManager/controlWrappers/reports_v2/header";

export function ReportPageV2(props) {
  const { setTitle, setMenuOptions } = useAppContainerContext()
  const [report, setReport] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()


  const init = useCallback(async ()=>{
    const { _id } = getURLDetails(location)
    let _r = await dataSource('remDb')[REP_V2].get({ _id })
    _r = new ReportV2(_r)
    let language = await dataSource('remDb')[LANG_V2].getTyped({ _id: _r[LANG_V2] })
    console.log('got init stuff', _r, language)
    _r[LANG_V2] = language

    setReport(_r)
    
  }, [location])

  useEffect(()=>{
    console.log('reportPageV2 setting menu options and title')
    let timeout_id = setTimeout(()=>{
      if(report) setTitle(`Report   |   ` + report.name)
      //setMenuOptions([])
    })
    return ()=>{clearTimeout(timeout_id)}

  },[report, setTitle, setMenuOptions])

  useEffect(() => {
    init()
  }, [init])

  const comp = useMemo(() => {
    let { report_blocks, report_top_blocks, preamble_blocks, language_v2, ...metadata } = report
    const reportMetadata = { ...metadata, language_v2:language_v2 && language_v2._id }
    let data = {
      content: report && report.getContents(report[LANG_V2].source),
      schemas: report && report.getSchemas(),
      source: report && { ...report[LANG_V2].source }
    }
    return report ? (
      (
      
     
          <NewControlManager
            registerGetData={(...a) => console.log('registerGetData', a)}
            onSubmit={(...a) => console.log('onSubmit', a)}
            content={data.content}
            schemas={data.schemas}
            source={data.source}
            objectMetadata={reportMetadata}
            options={{ modules: {body:ReportBodyWrapper, header:ReportHeaderWrapper}}}
          />
   
        
      )
    ) : []
  }, [report])

  function handleBack() {
    navigate('/home')
  }

  return (
    <div style={{ position: 'relative', height: '100%' }} className="report-page-container">
      {/* Main report content */}
        {comp}
    </div>
  );
}